export const formatPhone = (phone) =>
	"+" + phone.slice(0, 2) + " " + phone.slice(2);
